/**
 * Formats a remaining duration as `mm:ss`.
 *
 * Not a countdown: that lives in `useCountdown` (Phase 3) so there is one timer app-wide. This is
 * the display formatting so `Countdown` never does arithmetic inline.
 */
export function formatRemainingMmSs(remainingMs: number): string {
  const clamped = Number.isFinite(remainingMs) ? Math.max(0, remainingMs) : 0;
  const totalSeconds = Math.floor(clamped / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}
